import { IItem } from ".";
import { instanceOfIItem } from "./IItem";

export interface IDesignatedDoctorNumberApplicable extends IItem {
  designatedDoctorNumberType: string;
  setDesignatedDoctorNumber(text: string): void;
  adjustFontSize(): void;
  isEmpty: boolean;
}

export function instanceOfIDesignatedDoctorNumberApplicable(instance: any): instance is IDesignatedDoctorNumberApplicable {
  if (!instance) { return false; }
  return (instance.designatedDoctorNumberType !== undefined)
    && (instance.setDesignatedDoctorNumber !== undefined)
    && (instance.isEmpty !== undefined)
    && instanceOfIItem(instance);
}
